import { NgModule } from '@angular/core';

import { SeguradorasComponent } from './seguradoras.component';
import { SharedModule } from "../../shared/shared.module";
import { SeguradoraListComponent } from './seguradora-list/seguradora-list.component';
import { SeguradoraFormComponent } from './seguradora-form/seguradora-form.component';
import { SeguradorasRoutingModule } from "./seguradoras-routing.module";
import { PessoaJuridicaModule } from "../../recursos-humanos/pessoa-juridica/pessoa-juridica.module";
import { SeguradoraApiService } from "./shared/seguradora-api.service";
import { SeguradoraNavigationService } from "./shared/seguradora-navigation.service";
import { SeguradoraService } from "./shared/seguradora.service";

@NgModule({
  imports: [
    SharedModule,
    PessoaJuridicaModule,
    SeguradorasRoutingModule
  ],
  providers: [
    SeguradoraApiService,
    SeguradoraNavigationService,
    SeguradoraService
  ],
  declarations: [
    SeguradorasComponent,
    SeguradoraListComponent,
    SeguradoraFormComponent
  ]
})
export class SeguradorasModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/despachos/seguradoras/seguradoras.module.ts
 **/